<template>
  <div>
    <div class="ulBox" v-if="!sidebarOpen">
      <div v-if="!menuList[0].children">
        <div
          class="activeInd"
          v-for="(item, index) in menuList"
          @click="change(item)"
          :key="index"
          width="150px"
        >
          <!-- 没有子集路由 -->
          <div
            style="transition: all 0.02s"
            v-if="!item.children"
            :class="activeIndex == item.id ? 'active' : ''"
          >
            <img
              class="squareTop square"
              style="width: 20px; position: absolute"
            />
            <!-- <p class="squareTop square"><img /></p> -->
            <div class="iconAndTitle" style="transition: all 0.02s">
              <div class="icon">
                <svg-icon
                  :icon-class="item.meta.icon"
                  :class="
                    activeIndex == item.id ? 'activeIcon' : 'noActiveIcon'
                  "
                ></svg-icon>
              </div>
              <p :class="activeIndex == item.id ? 'itemTitle1' : 'itemTitle2'">
                {{ item.meta.title }}
              </p>
            </div>
            <img
              class="squareBtm square"
              style="width: 20px; position: absolute"
            />
            <!-- <p class="squareBtm square"><img /></p> -->
          </div>
        </div>
      </div>
      <div v-else>
        <son
          :item="menuList"
          :activeIndex="activeIndex"
          :ChildrenactiveIndex="ChildrenactiveIndex"
          :fatherId="fatherId"
        ></son>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import son from "./son.vue";
export default {
  components: { son },
  computed: {
    ...mapState({
      sidebarOpen: (state) => state.app.sidebar.opened,
    }),
  },
  comments: {
    son,
  },
  beforeMount() {
    this.getList();
  },
  mounted() {
    this.IsPC();
  },
  data() {
    return {
      menuList: "",
      activeIndex: 0,
      show: false,
      ChildrenactiveIndex: "",
      sidelistShow: false,
      fatherId: "",
    };
  },
  methods: {
    change(item) {
      if (this.sidelistShow) {
        setTimeout(() => {
          this.sidelistShow = false;
        }, 50);
      }
      this.activeIndex = item.id;
      this.$router.push({ path: item.path });
      this.sidelistShow = true;
    },
    getList() {
      this.menuList = [];
      let params = this.$store.state.permission.sidebarRouters;
      params.forEach((item) => {
        if (this.$route.matched.length == 2) {
          if (item.path == this.$route.matched[0].path) {
            if (item.children) {
              this.menuList = item.children;
              item.children.forEach((item) => {
                if (item.name == this.$route.name) {
                  this.activeIndex = item.id;
                }
              });
            }
          }
        } else if (this.$route.matched.length > 2) {
          if (item.path == this.$route.matched[0].path) {
            if (item.children) {
              this.menuList = item.children;
              item.children.forEach((item2) => {
                if (item2.title == this.$route.matched[1].meta.title) {
                  this.fatherId = item2.id;
                  item2.children.forEach((item3) => {
                    if (item3.name == this.$route.matched[2].name) {
                      this.activeIndex = item3.id;
                    }
                  });
                }
              });
            }
          }
        }
      });
    },
    IsPC() {
      let userAgent = navigator.userAgent.toLowerCase();
      // 用 test 匹配浏览器信息
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          userAgent
        )
      ) {
        this.mobile = false;
        this.show = false;
        // console.log("前端是移动端");
      } else {
        this.mobile = true;
        this.show = true;
        // console.log("前端是pc端");
      }
    },
  },
  watch: {
    $route: function () {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "~@/assets/styles/handle.scss";
* {
  padding: 0;
  margin: 0;
}
.ulBox {
  width: 150px;
  margin-top: 20px;
  float: right;
  font-size: 13px;
  border-radius: 10px 0 0 10px;
  transition: all 0.5s;
}
.activeInd {
  width: 100%;
  height: 60px;
  position: relative;
  cursor: pointer;
}

.active {
  background: #fff;
  height: 60px;
  border-radius: 10px 0 0 10px;
  position: relative;
}

.active > .square {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  box-sizing: border-box;
}
.active > .square::after {
  content: "";
  width: 100%;
  height: 100%;
  background: rgb(1, 124, 1, 0);
  // position: absolute;
  bottom: 0;
  right: 0;
}
.active > .squareTop {
  top: -20px;
  content: url("~@/assets/images/corner.svg");
}
// img:not([src]) {
//   opacity: 0;
// }
.active > .squareBtm {
  border: none;
  bottom: -20px;
  content: url("~@/assets/images/corner.svg");
  transform: rotate(-90deg);
}
/* .active > .squareTop::after {
  border-radius: 0 0 10px 0;
}
.active > .squareBtm::after {
  border-radius: 0 50% 0 0;
} */
.activeIcon {
  text-align: center;
  vertical-align: middle;
  width: 25px;
  height: 25px;
  margin-left: calc(50% - 15px);
  margin-top: 10px;
  margin-bottom: 3px;
  fill: currentColor;
  overflow: hidden;
}
.noActiveIcon {
  color: white;
  text-align: center;
  vertical-align: middle;
  width: 25px;
  height: 25px;
  margin-left: calc(50% - 15px);
  margin-top: 10px;
  margin-bottom: 3px;
  fill: currentColor;
  overflow: hidden;
}

.svg-icon {
  width: 25px;
  height: 25px;
  margin-left: calc(50% - 15px);
  margin-top: 10px;
  margin-bottom: 3px;
  fill: currentColor;
  overflow: hidden;
}
.itemTitle1 {
  text-align: center;
  cursor: pointer;
}
.itemTitle2 {
  cursor: pointer;
  text-align: center;
  color: white;
}
</style>
